import { render, staticRenderFns } from "./DigitalDownloadPreview.vue?vue&type=template&id=338d0768&scoped=true"
import script from "./DigitalDownloadPreview.vue?vue&type=script&lang=js"
export * from "./DigitalDownloadPreview.vue?vue&type=script&lang=js"
import style0 from "./DigitalDownloadPreview.vue?vue&type=style&index=0&id=338d0768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d0768",
  null
  
)

export default component.exports